import React from "react";

export default function SosTab() {
  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">In the Storm</h2>
        <span className="xs muted">
          For when things feel overwhelming or out of control.
        </span>
      </div>

      <div className="grid md-g-3">
        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            The STOP Practice
          </h3>
          <ol className="sm" style={{ paddingLeft: 18, margin: 0 }}>
            <li>
              <strong>S — Stop.</strong> Pause just for a moment. Put things
              down.
            </li>
            <li>
              <strong>T — Take a breath.</strong> Feel one full inhale and
              exhale.
            </li>
            <li>
              <strong>O — Observe.</strong> Notice body, emotions, thoughts, and
              the urge to react.
            </li>
            <li>
              <strong>P — Proceed.</strong> From here, choose the next gentle,
              wise step.
            </li>
          </ol>
        </div>

        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            Anchors
          </h3>
          <ul className="sm" style={{ paddingLeft: 18, margin: 0 }}>
            <li>Feel your feet on the ground.</li>
            <li>Find one sound in the room and stay with it for 10 seconds.</li>
            <li>Place a hand on your heart or belly and feel the contact.</li>
            <li>Name five things you can see right now.</li>
          </ul>
        </div>

        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            When You Need More Support
          </h3>
          <p className="sm">
            Mindfulness is not a substitute for professional care. If you are
            feeling unsafe or in crisis, please reach out to someone you trust
            or a local crisis resource.
          </p>
          <ul className="xs muted" style={{ paddingLeft: 18, margin: 0 }}>
            <li>A trusted friend, partner, or family member</li>
            <li>Your therapist, coach, or doctor</li>
            <li>A local emergency or crisis hotline</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
